import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as searchActions from './reducer';

import './Search.css';

export class SearchComponent extends Component {
  static get propTypes() {
    // Dev hint for expected props.
    return { onSearchForId: PropTypes.func.isRequired,
      currentId: PropTypes.number,
      type: PropTypes.string.isRequired
    };
  }

  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  componentWillReceiveProps(props) {
    // Clear searched id if new record is loaded.
    // Do not clear on error or if record matches searched for  id
    if (this.props.currentId !== props.currentId && this.state.value !== props.currentId) {
      this.setState({ value: '' });
    }
  }


  onSubmit(event) {
    // Create short hand for prop and state members
    const { onSearchForId } = this.props;
    const { value } = this.state;
    event.preventDefault();

    // Call connected action that dispatches the action with the new intended state
    onSearchForId(value);
  }

  onChange(input) {
    // Validate value. Ignore invalid entries
    const searchVal = parseInt(input.target.value, 10);
    if (searchVal) {
      this.setState({ value: searchVal });
    }
  }

  render() {
    const searchVal = this.state.value;
    let type = this.props.type;
    type = type.charAt(0).toUpperCase() + type.slice(1);

    return (
      <div className="Search">
        <form onSubmit={event => this.onSubmit(event)}>
          <input className="Search-input" type="text" value={searchVal} onChange={input => this.onChange(input)} placeholder={`${type} Id`} />
          <input type="submit" className="btn btn-primary" value="Search" disabled={!searchVal} />
        </form>
      </div>);
  }
}

const mapStateToProps = state => ({
  currentId: state.recordDetail.currentId,
  type: state.recordList.type
});


// Binding our action creator to the redux dispatcher and makes the bound action available in props
const mapDispatchToProps = (dispatch) => {
  const { searchForId
  } = bindActionCreators(searchActions, dispatch);

  return {
    onSearchForId: searchForId
  };
};

const Search = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchComponent));
export default Search;



// WEBPACK FOOTER //
// ./src/search/Search.js